import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class NoteService extends AbstractService {
	static endpoint = ENDPOINTS.notes;

	static notesApi = NexusService.notesApi;

	static apiCoreEndpointsFeature = "use_api_core_endpoints_notes";

	static getAll(queryParams, getCancelToken) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {};
			if (Object.hasOwn(queryParams, "pageNumber")) {
				request.pageNumber = queryParams.pageNumber;
			}
			if (Object.hasOwn(queryParams, "displayCount")) {
				request.displayCount = queryParams.displayCount;
			}
			if (Object.hasOwn(queryParams, "jobEventId")) {
				request.jobEventId = queryParams.jobEventId;
			}
			if (Object.hasOwn(queryParams, "jobId")) {
				request.jobId = queryParams.jobId;
			}
			if (Object.hasOwn(queryParams, "clientId")) {
				request.clientId = queryParams.clientId;
			}
			if (Object.hasOwn(queryParams, "projectId")) {
				request.projectId = queryParams.projectId;
			}
			if (Object.hasOwn(queryParams, "locationId")) {
				request.locationId = queryParams.locationId;
			}
			if (Object.hasOwn(queryParams, "locationGroupId")) {
				request.locationGroupId = queryParams.locationGroupId;
			}
			if (Object.hasOwn(queryParams, "startDate" && queryParams.startDate)) {
				request.startDate = new Date(queryParams.startDate);
			}
			if (Object.hasOwn(queryParams, "endDate") && queryParams.endDate) {
				request.endDate = new Date(queryParams.endDate);
			}
			return this.notesApi.getTokenizedNotes(request, getCancelToken).then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}

		return this.get({
			endpoint: this.endpoint,
			queryParams,
			getCancelToken,
		});
	}

	static delete({ id, queryParams, data }) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			return this.notesApi
				.deleteNote({
					id,
				})
				.then(response => ({ data: response }))
				.catch(error => {
					const apiResponse = {
						data: error,
					};
					return apiResponse;
				});
		}

		return this.del({
			endpoint: `${this.endpoint}/${id}`,
			queryParams,
			data,
		});
	}

	static uploadNoteImage({ fileData, queryParams }) {
		const data = new FormData();
		data.append("file", fileData);
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				locationId: queryParams.locationId,
				file: fileData,
			};
			return this.notesApi.uploadPicture(request).then(response => ({ data: response }));
		}

		return this.post({
			endpoint: `${this.endpoint}/picture`,
			queryParams,
			data,
		});
	}

	static addNote({ queryParams, data }) {
		if (FeatureFlagService.isEnabled(this.apiCoreEndpointsFeature)) {
			const request = {
				noteCreatePayload: {},
			};

			if (Object.hasOwn(data, "Comment")) {
				request.noteCreatePayload.Comment = data.Comment;
			}
			if (Object.hasOwn(data, "CloudFilePictureId")) {
				request.noteCreatePayload.CloudFilePictureId = data.CloudFilePictureId;
			}
			if (Object.hasOwn(data, "JobEventId")) {
				request.noteCreatePayload.JobEventId = data.JobEventId;
			}
			if (Object.hasOwn(data, "LocationId")) {
				request.noteCreatePayload.LocationId = data.LocationId;
			}
			if (Object.hasOwn(data, "NoteTypeId")) {
				request.noteCreatePayload.NoteTypeId = data.NoteTypeId;
			}

			return this.notesApi.createNote(request).then(response => ({ data: response }));
		}
		return this.post({
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}
}
